export const SuccessHandler = response => {
  return response;
};
